<p-panel
  class="specific-class widget-first-level"
  header="Documents"
  toggler="header"
  [toggleable]="true"
  [collapsed]="collapsed"
  (collapsedChange)="collapsedChange.emit($event)"
>
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-right duration-150" [class]="{ 'rotate-90': !collapsed }"></i>
  </ng-template>
  @if (isLoading) {
    <p-progressSpinner/>
  } @else {
    <div class="mb-6">
      <span class="font-bold mr-2">Authorization Number:</span>
      <span>{{ authorizationNumber }}</span>
    </div>
    <p-tabs [(value)]="activeTabIndex">
      <p-tablist>
        <p-tab [value]="0">Documents</p-tab>
        @if (platformService.widgetFeatures.uploadDocuments) {
          <p-tab [value]="1">Upload Files</p-tab>
        }
        @if (platformService.widgetFeatures.sendFax) {
          <p-tab [value]="2">Send Fax</p-tab>
        }
        @if (platformService.widgetFeatures.moveDocuments) {
          <p-tab [value]="3">Move Documents</p-tab>
        }
        @if (platformService.widgetFeatures.uploadLetter) {
          <p-tab [value]="4">Upload Letters</p-tab>
        }
        @if (platformService.widgetFeatures.agNotesReport) {
          <p-tab [value]="5">A&G Notes Report</p-tab>
        }
        @if (platformService.widgetFeatures.eNotification) {
          <p-tab [value]="6">E-Notification</p-tab>
        }
        @if (platformService.widgetFeatures.appealsPacket) {
          <p-tab [value]="7">Appeals Packet</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <mnc-documents-documents-list
            [authorizationByProductId]="authorizationByProductId"
            [authorizationNumber]="authorizationNumber"
            [documents]="documents"
            [filterable]="platformService.widgetFeatures.filtersEnabled"
            [isDocumentsTab]="true"
            [isExternal]="isExternal"
            [lineOfBusinessId]="lineOfBusinessId"
            [providerNPI]="servicingProvider?.providerAccountDTO?.npi"
            [selectable]="platformService.widgetFeatures.downloadPacket"
            [showChecked]="!isExternal"
            [tenantId]="tenantId"
            [tenantName]="tenantName"
            (deleteCompleted)="getDocuments()"
            (editCompleted)="updateDocumentReceivedTime($event)"
          >
          </mnc-documents-documents-list>
        </p-tabpanel>
        @if (platformService.widgetFeatures.uploadDocuments) {
          <p-tabpanel [value]="1">
            <mnc-documents-upload
              [authorization]="authorizationDto"
              [authorizationByProductId]="authorizationByProductId"
              [authorizationNumber]="authorizationNumber"
              [documents]="documents"
              [isExternal]="isExternal"
              [lineData]="lineData"
              [lineOfBusinessId]="lineOfBusinessId"
              [memberDto]="memberDto"
              [providerNPI]="servicingProvider?.providerAccountDTO?.npi"
              [servicingProvider]="servicingProvider"
              [tenantId]="tenantId"
              [tenantName]="tenantName"
              (closeNote)="closeNotesOnStreamCheck()"
              (routerEvents)="routerEvents.emit($event)"
              (selectedFiles)="onUpload($event)"
              (uploadComplete)="onDocumentUpload()"
            />
          </p-tabpanel>
        }
        @if (platformService.widgetFeatures.sendFax) {
          <p-tabpanel [value]="2">
            <mnc-documents-send-fax
              [additionalProps]="additionalProps"
              [authorization]="authorization"
              [authorizationByProductId]="authorizationByProductId"
              [authorizationDto]="authorizationDto"
              [authorizationNumber]="authorizationNumber"
              [documents]="documents"
              [isExternal]="isExternal"
              [lineData]="lineData"
              [memberDto]="memberDto"
              [orderingProvider]="orderingProvider"
              [servicingProvider]="servicingProvider"
              [tenantId]="tenantId"
              [tenantName]="tenantName"
              (closeNotes)="closeNotes()"
              (openDocument)="openDocuments($event)"
              (openNote)="openNotes($event)"
              (sendFaxCompleted)="goToDocsWithDelay()"
            />
          </p-tabpanel>
        }
        @if (platformService.widgetFeatures.moveDocuments) {
          <p-tabpanel [value]="3">
            <!-- todo: find better solution instead magic tab index -->
            @if (authorizationDto && activeTabIndex === 3) {
              <mnc-documents-documents-move
                [activeAuthorization]="authorizationDto"
                [documents]="documents"
                [documentsListFilterable]="platformService.widgetFeatures.moveDocumentsListFilterable"
                [documentsListPreviewColumnFilter]="platformService.widgetFeatures.moveDocumentsListPreviewColumnFilter"
                [memberDto]="memberDto"
                [tenantId]="tenantId"
                (deletedDocument)="getDocuments()"
                (movedDocuments)="goToAndRefreshDocs()"
              />
            }
          </p-tabpanel>
        }
        @if (platformService.widgetFeatures.uploadLetter) {
          <p-tabpanel [value]="4">
            @if (authorizationDto) {
              <mnc-documents-documents-upload-letter
                [authorization]="authorizationDto"
                [lineData]="lineData"
                [servicingProvider]="servicingProvider"
                [tenantId]="tenantId"
                [tenantName]="tenantName"
                (closeNotes)="closeNotes()"
                (uploadLetterComplete)="uploadLetterComplete()"
              />
            }
          </p-tabpanel>
        }
        @if (platformService.widgetFeatures.agNotesReport) {
          <p-tabpanel [value]="5">
            @if (lineData) {
              <mnc-documents-ag-notes-report
                [authorizationByProductId]="authorizationByProductId"
                [lineData]="lineData"
              />
            }
          </p-tabpanel>
        }
        @if (platformService.widgetFeatures.eNotification) {
          <p-tabpanel [value]="6">
            @if (eNotifications !== null) {
              <mnc-document-e-notification
                [authorizationByProductId]="authorizationByProductId"
                [eNotifications]="eNotifications"
                [tenantId]="tenantId"
              />
            }
          </p-tabpanel>
        }
        @if (platformService.widgetFeatures.appealsPacket) {
          <p-tabpanel [value]="7">
            <mnc-appeals-packet
              [authorizationByProductId]="authorizationByProductId"
              [authorizationNumber]="authorizationNumber"
              [documents]="documents"
              [isExternal]="isExternal"
              [tenantId]="tenantId"
              [tenantName]="tenantName"
              [lineOfBusiness]="platformService.lineOfBusiness"
              (appealPacketGenerated)="refreshDocsAfterAppealPacket()"
            />
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  }
</p-panel>


<mnc-documents-shared-toast/>
<mnc-documents-shared-confirmation/>
